import { Component } from 'react';
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import { updateData } from './constants.js';
const moment = require('moment');

class MyProfile extends Component {
  constructor(props){
    super(props);
    this.state = {
      data  : {},
      show  : false,
      isLoading : true
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.editProfile = this.editProfile.bind(this);
  }

  async getProfileDetails() {
    try {
      const response = await fetch('/api/my-profile/');
      const json = await response.json();
      this.setState({data: json});
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({isLoading: false});
    }
  }

  componentDidMount() {
    this.getProfileDetails();
  }

  editProfile(e) {
    this.setState({
      show: true,
      email : this.state.data.email
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading:true });
    delete data.data;
    updateData('/api/update-profile', data)
      .then((response) => {
        console.log(response);
        this.getProfileDetails();
    });
  }

  render(){
    const data = this.state.data;
    return (
      <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                      {this.state.isLoading?
                        <> </>
                      :
                        <>
                         <div className="row">
                            <div className="col-xs-12 col-md-6 col-lg-6">
                              <div className="card shadow-sm mb-2">
                                <div className="card-header d-flex justify-content-between font-weight-bold">
                                    <h3 className="m-0 font-weight-bold text-light">Profile details</h3>
                                </div>
                                <div className="card-body">
                                  <div className="row mb-3">
                                    <div className="col-xs-6 col-md-4 font-weight-bold">Username </div>
                                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.username} </div>
                                  </div>
                                  <div className="row my-3">
                                    <div className="col-xs-6 col-md-4 font-weight-bold">User Role</div>
                                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.user_role} </div>
                                  </div>
                                  <div className="row my-3">
                                    <div className="col-xs-6 col-md-4 font-weight-bold">Email </div>
                                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.email} </div>
                                  </div>
                                </div>
                              </div>
                              <button className="btn btn-primary" onClick={this.editProfile}><i className="fas fa-pencil-alt mr-2"></i>Edit Profile</button>
                            </div>
                            <div className="col-xs-12 col-md-6 col-lg-6">
                              {this.state.show?(
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h3 className="m-0 font-weight-bold text-light">Edit Profile</h3>
                                    </div>
                                    <div className="card-body profile-form">
                                        <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                                            <div className="form-group">
                                                <label>Email </label>
                                                <input type="email" name="email" className="form-control" value={this.state.email} onChange={this.handleInputChange} required />
                                                <small>(Be sure that your email id is correct!. It is used to login your account)</small>
                                            </div>
                                            <div className="form-group">
                                              <input type="submit" id="profile-submit" className="btn btn-primary" value="Submit" />
                                              <button type="button" name="cancel" className="btn btn-light mx-1" onClick={()=> this.setState({show:false})}>Cancel</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                              ):(
                                <> </>
                              )}
                            </div>
                         </div>
                        </>
                      }
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
      </>
    );
  }
}

export { MyProfile };
